import React from 'react';

import { Icon } from 'js/components';
import { faX } from '@fortawesome/pro-regular-svg-icons';

import EditorInput from 'js/components/Assessment/Editors/common/components/EditorInput';
import SentimentMarker from 'js/components/Icons/SentimentMarker';
import { MIN_SENTIMENT_OPTIONS } from 'js/utils/sentiment-question';

import DraggableSentimentOption from './DraggableSentimentOption';

import styles from './Sentiment.module.scss';

/**
 * One sentiment choice: icon, text, and delete. When the set is inline the
 * row is a drag target; a borrowed standard set is the same row without
 * the handle.
 */
export default function SentimentOption({
  choice,
  index,
  questionId,
  answerSetId,
  icon,
  rotate,
  shrink,
  color,
  ink,
  colorOnly = false,
  canReorder,
  canRemove,
  onMove = () => {},
  onChoiceUpdate = () => {},
  onDeleteChoice = () => {},
}) {
  const choiceId = choice.guid ?? choice.id;

  const handleTextChange = (e) => {
    const text = e.target.value.trim();
    if (text === choice.text) {
      return;
    }
    onChoiceUpdate(answerSetId, choiceId, { text });
  };

  const body = (
    <>
      <div
        className={styles.decoration}
        style={{ '--response-color': color, '--response-ink': ink }}
      >
        <SentimentMarker
          icon={icon}
          rotate={rotate}
          shrink={shrink}
          colorOnly={colorOnly}
        />
      </div>
      <div className={styles['option-text']}>
        <EditorInput
          autoselect
          forceCommitOnEnter
          multiLine
          autosize
          minRows={1}
          value={choice.text}
          placeholder="Describe this option"
          onBlur={handleTextChange}
        />
      </div>
      <div className={styles['option-actions']}>
        <button
          type="button"
          className="btn-inline-action btn-danger"
          disabled={!canRemove}
          title={
            canRemove
              ? 'Remove this option'
              : `A sentiment scale needs at least ${MIN_SENTIMENT_OPTIONS} options`
          }
          onClick={() => onDeleteChoice(answerSetId, choiceId, questionId)}
        >
          <Icon icon={faX} size="sm" />
        </button>
      </div>
    </>
  );

  return !canReorder ? (
    <div className={`${styles.option} ${styles['option-static']}`}>{body}</div>
  ) : (
    <DraggableSentimentOption
      choice={choice}
      index={index}
      questionId={questionId}
      answerSetId={answerSetId}
      icon={icon}
      rotate={rotate}
      shrink={shrink}
      color={color}
      ink={ink}
      colorOnly={colorOnly}
      onMove={onMove}
    >
      {body}
    </DraggableSentimentOption>
  );
}
